import React from 'react';
import PropTypes from 'prop-types';
import { IconChevronLeft } from 'components/Icons';

const BackButton = props => {
    return (
        <div className="syos-back-button">
            {props.returnUrl && (
                <a href={props.returnUrl}
                    className="syos-button syos-button--back">
                    <IconChevronLeft /> Back
                </a>
            )}
        </div>
    )
};
BackButton.propTypes = {
    returnUrl: PropTypes.string
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/BackButton.js